import { Divider as AntDivider } from 'antd';
import isNil from 'lodash/isNil';
import React from 'react';

import { coolGrey } from 'style/colour-palette';

type DividerProps = {
  color?: string;
  /** Overrides ant-divider-horizontal '24px 0' */
  margin?: number;
  vertical?: boolean;
};

function Divider({
  color: colorProp,
  margin: marginProp,
  vertical
}: DividerProps): JSX.Element {
  const borderColor = colorProp ?? coolGrey;

  let margin: string | undefined = undefined;
  if (!isNil(marginProp)) {
    margin = vertical ? `0 ${marginProp}px` : `${marginProp}px 0`;
  }

  const type = vertical ? 'vertical' : 'horizontal';

  return <AntDivider type={type} style={{ borderColor, margin }} />;
}

export default Divider;
export type { DividerProps };
